export enum EmployeeSeniority {
	Junior = 'Junior',
	Intermediate = 'Intermediate',
	Senior = 'Senior'
}
